'use client';

import React, { useState, useEffect } from 'react';
import ContactMethodCard from './ContactMethodCard';
import ConsultationBookingModal from './ConsultationBookingModal';
import ExpertCallModal from './ExpertCallModal';
import GeneralInquiryModal from './GeneralInquiryModal';

const ContactInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [activeModal, setActiveModal] = useState<'consultation' | 'expert' | 'inquiry' | null>(null);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <section className="py-16 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="animate-pulse">
            <div className="h-8 bg-muted rounded w-1/2 mx-auto mb-4" />
            <div className="h-4 bg-muted rounded w-1/3 mx-auto mb-12" />
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[1, 2, 3]?.map((i) => (
                <div key={i} className="h-80 bg-muted rounded-lg" />
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <>
      <section className="py-16 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-headline font-bold text-foreground mb-4">
              Choose Your Preferred Contact Method
            </h2>
            <p className="text-lg text-muted-foreground font-body max-w-2xl mx-auto">
              Select the option that best fits your needs. We're committed to responding promptly and professionally.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <ContactMethodCard
              icon="CalendarDaysIcon"
              title="Schedule Consultation"
              description="Book a dedicated time slot with our experts. Choose your preferred date, time, and specialist based on your project needs."
              action="Book Consultation"
              highlight={true}
              onClick={() => setActiveModal('consultation')}
            />
            <ContactMethodCard
              icon="PhoneIcon"
              title="Request Expert Call"
              description="Need immediate technical guidance? Request a call from our specialists who can address your specific challenges."
              action="Request Call"
              onClick={() => setActiveModal('expert')}
            />
            <ContactMethodCard
              icon="EnvelopeIcon"
              title="General Inquiry"
              description="Have questions about our services, partnerships, or careers? Send us a message and we'll respond within 24 hours."
              action="Send Message"
              onClick={() => setActiveModal('inquiry')}
            />
          </div>
        </div>
      </section>

      <ConsultationBookingModal
        isOpen={activeModal === 'consultation'}
        onClose={() => setActiveModal(null)}
      />
      <ExpertCallModal
        isOpen={activeModal === 'expert'}
        onClose={() => setActiveModal(null)}
      />
      <GeneralInquiryModal
        isOpen={activeModal === 'inquiry'}
        onClose={() => setActiveModal(null)}
      />
    </>
  );
};

export default ContactInteractive;